import Link from "next/link";

export const Footer = () => {
	return (
		<footer className="bg-mgt-black border-t border-brown/50 mt-auto">
			<div className="max-w-6xl mx-auto px-4 py-8">
				<div className="grid grid-cols-1 md:grid-cols-4 gap-8">
					{/* Company Info */}
					<div className="space-y-4">
						<h3 className="text-lg font-semibold text-mgt-green">
							MyGeoTokens
						</h3>
						<p className="text-off-white text-sm leading-relaxed">
							Discover, drop, and trade location-based NFTs on the Solana
							blockchain.
						</p>
					</div>

					{/* Quick Links */}
					<div className="space-y-4">
						<h4 className="text-md font-medium text-white">Platform</h4>
						<ul className="space-y-2">
							<li>
								<Link
									href="/about"
									className="text-off-white hover:text-mgt-green transition-colors text-sm"
								>
									About
								</Link>
							</li>
							<li>
								<Link
									href="/drop-nft"
									className="text-off-white hover:text-mgt-green transition-colors text-sm"
								>
									Drop NFTs
								</Link>
							</li>
							<li>
								<Link
									href="/wallet"
									className="text-off-white hover:text-mgt-green transition-colors text-sm"
								>
									Wallet
								</Link>
							</li>
							<li>
								<Link
									href="/profile"
									className="text-off-white hover:text-mgt-green transition-colors text-sm"
								>
									Profile
								</Link>
							</li>
						</ul>
					</div>

					{/* Support */}
					<div className="space-y-4">
						<h4 className="text-md font-medium text-white">Support</h4>
						<ul className="space-y-2">
							<li>
								<Link
									href="/guide"
									className="text-off-white hover:text-mgt-green transition-colors text-sm"
								>
									Start Guide
								</Link>
							</li>
							<li>
								<Link
									href="/faqs"
									className="text-off-white hover:text-mgt-green transition-colors text-sm"
								>
									FAQs
								</Link>
							</li>
							<li>
								<a
									href="https://discord.gg/UpxTdUVkKy"
									target="_blank"
									rel="noopener noreferrer"
									className="text-off-white hover:text-mgt-green transition-colors text-sm"
								>
									Join Discord
								</a>
							</li>
						</ul>
					</div>

					{/* Legal */}
					<div className="space-y-4">
						<h4 className="text-md font-medium text-white">Legal</h4>
						<ul className="space-y-2">
							<li>
								<Link
									href="/terms"
									className="text-off-white hover:text-mgt-green transition-colors text-sm"
								>
									Terms of Service
								</Link>
							</li>
							<li>
								<Link
									href="/privacy"
									className="text-off-white hover:text-mgt-green transition-colors text-sm"
								>
									Privacy Policy
								</Link>
							</li>
						</ul>
					</div>
				</div>

				{/* Bottom Bar */}
				<div className="border-t border-brown/50 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
					<p className="text-off-white text-sm">
						© {new Date().getFullYear()} MyGeoTokens Inc. All rights reserved.
					</p>
					<div className="flex space-x-6">
						<Link
							href="/terms"
							className="text-off-white hover:text-mgt-green transition-colors text-sm"
						>
							Terms
						</Link>
						<Link
							href="/privacy"
							className="text-off-white hover:text-mgt-green transition-colors text-sm"
						>
							Privacy
						</Link>
						<Link
							href="/faqs"
							className="text-off-white hover:text-mgt-green transition-colors text-sm"
						>
							Help
						</Link>
					</div>
				</div>
			</div>
		</footer>
	);
};
